import React, { useState } from "react";
import TableCheckbox from "./TableCheckbox";
const TableRow = ({
  periodista,
  selectedPeriodistas,
  setSelectedPeriodistas,
  maxPreacreditados
}) => {
  const [checked, setChecked] = useState(false);
  const handleChange = (event) => {
    const periodistasCopia = [...selectedPeriodistas];
    if (!checked) {
      if (selectedPeriodistas.length >= maxPreacreditados) return;
      periodistasCopia.push(periodista);
      setChecked(true);
    } else {
      const index = periodistasCopia.indexOf(periodista);
      periodistasCopia.splice(index, 1);
      setChecked(false);
    }
    setSelectedPeriodistas(periodistasCopia);
  };

  return (
    <tr className={`${checked ? "active" : ""}`} onClick={handleChange}>
      <td>
        <p>{periodista.nombre}</p>
        <span>{periodista.cargo}</span>
      </td>
      <td>DNI: {periodista.dni}</td>
      <td>{periodista.mail}</td>
      <td>{periodista.celular}</td>
      <td className="td-checkbox">
        <TableCheckbox isChecked={checked} value={periodista} />
      </td>
    </tr>
  );
};

export default TableRow;
